import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import SEOHead from "@/lib/seo/SEOHead";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return <div className="min-h-screen flex items-center justify-center bg-white p-6">
    <SEOHead path="/reset-password" title="Choose New Password | RankTrust" />
    <div className="w-full max-w-md">
      <Link to="/" className="inline-block mb-8"><img src="/ranktrust-logo.png?v=5" alt="RankTrust" className="h-10 w-auto rounded-lg bg-[#0A1022] px-3 py-2"/></Link>
      <h1 className="text-3xl font-black text-zinc-900">Choose a new password</h1>
      {!token ? <div className="mt-6 rounded-xl border border-red-200 bg-red-50 p-4 text-red-800">This reset link is missing its security token. Request a new reset email.</div> :
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div><label className="label-tiny block mb-2">New password</label><input className="input-field" type="password" minLength={8} required value={password} onChange={(e)=>setPassword(e.target.value)} /></div>
        <div><label className="label-tiny block mb-2">Confirm new password</label><input className="input-field" type="password" minLength={8} required value={confirm} onChange={(e)=>setConfirm(e.target.value)} /></div>
        <button type="submit" className="btn-primary w-full justify-center" disabled={busy}>{busy ? <span className="spinner"></span> : "Update password"}</button>
      </form>}
      <div className="mt-6 text-sm"><Link to="/forgot-password" className="text-[#002FA7] font-semibold hover:underline">Request a new reset link</Link></div>
    </div>
  </div>;
}
